<template>
  <div
    :class="['container-progress-bar', `${coverSizeClass}-progress-bar`]"
    data-wptv="progress-bar-container">
    <div class="progress-bar-content">
      <div class="progress-background" />
      <div
        :class="[disabled ? 'disabled' : progressBarColor, 'progress-bar']"
        :style="{ width: + progressValueCaped + '%' }"
        :data-wptv="dataWptv" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'WptvProgressBar',
  props: {
    progressValue: {
      type: Number,
      required: true
    },
    threshold: {
      type: Number,
      default: -1
    },
    dataWptv: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    coverSizeClass: {
      type: String,
      default: 'large'
    }
  },
  computed: {
    progressBarColor () {
      return this.threshold >= 0 && this.progressValue >= this.threshold ? 'progress-bar-full' : 'progress-bar-default-color'
    },
    progressValueCaped () {
      return isNaN(this.progressValue) || this.progressValue === undefined ? 0 : Math.min(100, Math.max(0, this.progressValue))
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables';
@import '../../scss/abstracts/mixins';

.container-progress-bar {
  position: absolute;
  height: 50%;
  bottom: 0;
  width: 100%;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.54));
  z-index: 2;

  .progress-bar-content {
    position: absolute;
    padding: 0 15px;
    bottom: 15px;
    height: 5px;
    width: calc(100% - 30px);
    margin-left: 15px;
  }

  &.tiny-progress-bar .progress-bar-content {
    padding: 0 5px;
    bottom: 5px;
    width: calc(100% - 10px);
    margin-left: 5px;
  }
  &.medium-progress-bar .progress-bar-content {
    padding: 0 10px;
    bottom: 10px;
    width: calc(100% - 20px);
    margin-left: 10px;
  }

  .progress-background {
    background-color: rgba(221, 221, 221, 0.5);
    width: 100%;
    height: 5px;
    position: absolute;
    top: 0;
    left: 0;
    opacity:0.5;
  }

  .progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 5px;
    min-width: 6px;
    max-width: calc(100% - 6px);
    background-color: $grey;
  }

  .progress-bar-full {
    background-color: #E70002;
  }

  .progress-bar-default-color {
    background-color: $primary;
  }

  .disabled {
    background-color: $grey;
  }
}
</style>
